module.exports = __webpack_public_path__ + "img/1f33d.8c8bfe1.svg";